import { Common } from '@factorin/domain';

import { FactorinViewColumn } from 'Modules/business/fapp';

import { DateCell, FilesCell, StringCell } from './fields';


const columns: Common.Catalog<FactorinViewColumn> = {
    Uid: {
        field: 'Uid',
        Cell: StringCell,
        sortable: false,
        minWidth: 30,
    },
    EmitentName: {
        field: 'EmitentName',
        Cell: StringCell,
        sortable: false,
        minWidth: 35,
    },
    Files: {
        field: 'Files',
        Cell: FilesCell,
        sortable: false,
        minWidth: 25,
    },
    IssuedDate: {
        field: 'IssuedDate',
        Cell: DateCell,
        sortable: false,
        fixedWidth: 20,
    },

};

const descisionsColumnOrder = [
    'Uid',
    'EmitentName',
    'Files',
    'IssuedDate',
];

export const descisionsColumns = descisionsColumnOrder.map(column => columns[column]);
